import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ResizeService } from 'src/app/shared/resize.service';
import { AuthService } from '../auth.service';
import { TokenStorageService } from 'src/app/auth/token-storage.service';
import { EMAIL_PATTERN, UserRole } from 'src/app/shared/common';
import { storage } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent implements OnInit {
  loginForm!: FormGroup;
  returnUrl!: string;

  isLoading$: Observable<boolean> | undefined;
  loginError: string[] = [];
  screenType!: string;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private tokenStorageService: TokenStorageService,
    private route: ActivatedRoute,
    private router: Router,
    private resizeService: ResizeService
  ) {
    this.resizeService.screenWidthChange$.subscribe({
      next: (res: string) => {
        this.screenType = res;
      },
    });
  }
  ngOnInit(): void {
    this.isLoading$ = this.authService.isLoading$;
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '';
    this.initForm();
  }

  initForm() {
    this.loginForm = this.fb.group({
      email: [null, [Validators.required, Validators.email, Validators.pattern(EMAIL_PATTERN)]],
      password: [null, [Validators.required]],
    });
  }

  login() {
    this.authService
      .login(this.loginForm.value['email'], this.loginForm.value['password'])
      .subscribe({
        next: this.handleUpdateResponse.bind(this),
        error: this.handleError.bind(this),
      });
  }
  handleUpdateResponse(response: { token?: { access?: string } } | undefined) {
    const accessToken = response?.token?.access;

    if (!accessToken) {
      this.loginError = ['Invalid login response'];
      return;
    }
    this.tokenStorageService.saveTokens(accessToken);
    const decoded = this.tokenStorageService.decodeAccessToken();

    if (decoded?.tenant_logo) {
      localStorage.setItem('LOGO', decoded.tenant_logo);
    }

    if (decoded?.role) {
      localStorage.setItem(storage.role, decoded.role);
    }

    const role = this.tokenStorageService.getCurrentRole();
    const redirectPath = this.returnUrl
      ? this.returnUrl
      : role === UserRole.ADMIN
        ? '/tenant'
        : '/';
    this.router.navigateByUrl(redirectPath);
  }
  handleError(error: { message?: { non_field_errors?: string | string[] } }) {
    this.loginError = [];

    const message = error?.message;

    if (message && message.non_field_errors) {
      const errors = Array.isArray(message.non_field_errors)
        ? message.non_field_errors
        : [message.non_field_errors];

      errors.forEach((errMsg: string) => {
        const lower = errMsg.toLowerCase();
        if (
          lower.includes('incorrect password') ||
          lower.includes('email or password is incorrect')
        ) {
          this.loginError.push('Email or password incorrect.');
        } else {
          this.loginError.push(errMsg);
        }
      });
    } else {
      this.loginError.push('An unexpected error occurred. Please try again.');
    }
  }
}
